<div class="flex flex-column align-items-center position-center text-align-center">
    <uvx-icon icon="logo-1"></uvx-icon>
    <h5 class="margin-bottom-xxs">Welcome to the Data Platform Prototype that I (Amanda Simonds) built!</h5>

    <p class="margin-bottom-xs">
        This prototype was used for usability testing for UIUX design and front end development of a beta release, data platform application.
        <br>Our aim was to conduct research on user intuitiveness around the workflows we were designing for.
    </p>
    <p>
        This prototype demonstrates proposed workflows and features. All visuals and content are
        placeholders only, and do not represent real-world examples. Feel free to look around!
    </p>
</div>
